import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import rgbToLab from '@fantasy-color/rgb-to-lab';
import labToRgb from '@fantasy-color/lab-to-rgb';
import Color from '@bubble-dev/fantasy-color';
import { mapColorSpace } from '@fantasy-color/map-color-space-polynomial';
import darkerCoefficients from './darker-coefficients.json';
import lighterCoefficients from './lighter-coefficients.json';
var darkeningTransformation = mapColorSpace(darkerCoefficients, 2);
var lighteningTransformation = mapColorSpace(lighterCoefficients, 2);

var toTuple = function toTuple(_ref) {
  var luminance = _ref.luminance,
      a = _ref.a,
      b = _ref.b;
  return [luminance, a, b];
};

var tupleToLab = function tupleToLab(_ref2) {
  var _ref3 = _slicedToArray(_ref2, 3),
      luminance = _ref3[0],
      a = _ref3[1],
      b = _ref3[2];

  return {
    luminance: luminance,
    a: a,
    b: b
  };
};

var rgbToColor = function rgbToColor(_ref4) {
  var red = _ref4.red,
      green = _ref4.green,
      blue = _ref4.blue;
  return Color.of(red, green, blue, 1);
};

export var hovered = function hovered(rgb) {
  var sourceInLab = rgbToLab(rgb);
  var targetInLab = sourceInLab.luminance > 30 ? darkeningTransformation(toTuple(sourceInLab)) : lighteningTransformation(toTuple(sourceInLab));
  return rgbToColor(labToRgb(tupleToLab(targetInLab)));
};
export var pressed = function pressed(rgb) {
  var sourceInLab = rgbToLab(rgb);
  var targetInLab = sourceInLab.luminance > 30 ? darkeningTransformation(toTuple(sourceInLab)) : lighteningTransformation(toTuple(sourceInLab));
  var middleInLab = {
    luminance: targetInLab[0] + (sourceInLab.luminance - targetInLab[0]) / 2,
    a: targetInLab[1] + (sourceInLab.a - targetInLab[1]) / 2,
    b: targetInLab[2] + (sourceInLab.b - targetInLab[2]) / 2
  };
  return rgbToColor(labToRgb(middleInLab));
};
//# sourceMappingURL=index.js.map